import QWLogo from './assets/images/quiz-wizards-logo.png';

import { FC } from 'react';
import { useTranslation } from 'react-i18next';

const Fallback:FC = () => {
  const { t } = useTranslation();

  return (
    <div
      className="
        p-4
        fixed top-0 left-0
        w-full h-full
        flex flex-col items-center gap-4
      "
      style={{
        background: 'linear-gradient(90deg, #0c141a 0%, #1d262d 100%)'
      }}
    >
      <img src={QWLogo} alt="Quiz Wizards" className="h-20 sm:h-24" />
      <div className="flex-grow flex flex-col justify-center gap-4">
        <h2 className="text-xl text-center text-white sm:text-3xl">{t('pages.fallback.title')}</h2>
        <p className="text-sm text-center text-white sm:text-lg">{t('pages.fallback.description')}</p>
      </div>
    </div>
  );
}

export default Fallback;
